import { CustomerNotificationDetailsI } from 'src/e2e-redesign/views/ApproveNewOffer/approval-submission-card';
import { ApplicationStage, PathType } from 'src/enums/aaso.enums';
import { E2eAppSettingsFormsI } from 'src/interfaces/application-settings.interfaces';
import { E2eProcessApplicationJobI, FormValuesI } from 'src/interfaces/e2e-state.interfaces';
import { ApplicationSubmissionStateDto, LenderOffersI } from 'src/interfaces/submissions.interfaces';

import { DisclosureAasoI } from './disclosures.interfaces';

export interface Verification {
  is_verified: boolean;
  ip_address: string;
}

export interface AasoUserSelectionDetails {
  lender_id: number;
  time: Date;
  time_unix: number;
  fp_unique_id: string; // MUST ALWAYS exist
  application_id?: string;
  offer_id?: string;
  pre_qualification_id?: string;
  token?: string;
  ip: string[];
  offer_object: any; // this is the actual offer object that we need to check
}

export interface AasoUserSelection {
  selections: AasoUserSelectionDetails[];
  final_selections: AasoUserSelectionDetails[];
}

export interface AasoOfferAcceptDetailsI {
  time: Date;
  time_unix: number;
  ip: string[];
}
export interface AasoOffersToAcceptI {
  // accepted_details: AasoOfferAcceptDetailsI;
  //
  lender_id: number;
  applicant_id: number;
  submission: ApplicationSubmissionStateDto;
  offer: LenderOffersI;
  verified?: boolean;
  store_id: number;
  otp?: {
    email?: string;
    sms?: string;
  };
  user_id: number;
  has_accepted?: boolean;
  has_rejected?: boolean;
  fp_unique_id: string;
  selection_details: AasoOfferAcceptDetailsI[];
  offer_link: string;
  form_id: string;
  logic_details?: CustomerNotificationDetailsI;
}

export interface AasoKickOffDetailsI {
  path_id: string;
  e2e_form_id: string;
  has_kicked_off: boolean;
  e2e_bull_jobs: Partial<E2eProcessApplicationJobI>[];
}

export enum ApplicationEvents {
  STARTED = 'started',
  GET_STARTED_CLICKED = 'get_started_clicked',
  FORM_CLICKED = 'form_clicked',
  FINAL_DISCLOSURE_CLICKED = 'final_disclosure_clicked',
  FORM_SUBMISSION_CLICKED = 'form_submission_clicked',
  ADDITIONAL_OPTIONS_CLICKED = 'additional_options_clicked',
}

export interface AASO {
  _id: string | undefined;
  application_state_id: string;
  current_stage: ApplicationStage;
  latest_applicant_event?: ApplicationEvents[];
  verification: Verification;
  path_type: PathType; // R:TODO E2E P3 - deprecate
  path_index?: number; // I don't think I can do this, but need to provide the id
  current_path_id?: string; // this is the current path id
  past_path_ids: string[];
  past_path_index: number[]; // if user moves to a next, path, we push so it goes in order [1,2,3]
  prime_eligible: boolean;
  disclosures: DisclosureAasoI[];
  kick_off_details: AasoKickOffDetailsI[];
  store_id: string;
  store_uuid: string;
  store_name: string;
  form_id: string;
  applicant_id: string;
  created_at: string;
  updated_at: string;
  selected_lender_id: string | null; // R:TODO E2E - deprecate this in favor of below
  user_selection?: AasoUserSelection;
  e2e_form_id?: string;
  e2e_job_details: E2eProcessApplicationJobI[];
  offers_to_review?: AasoOffersToAcceptI[];
  e2e_form_snapshot?: E2eAppSettingsFormsI;
}
